var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"componentBox"},[_c('h2',{staticClass:"componentTitle"},[_vm._v("基础信息")]),_c('Cell',{attrs:{"colList":_vm.list,"detail":_vm.detail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }